// extracted by mini-css-extract-plugin
module.exports = {"FormSubmissionPolicy":"FormSubmissionPolicy_FormSubmissionPolicy__2a44k"};